import type React from 'react';

import styles from './HelperMessage.module.scss';

interface Props {
  helperMessage: React.ReactNode;
}
const HelperMessage: React.FC<Props> = ({ helperMessage }) =>
  helperMessage ? <p className={styles.helperText}>{helperMessage}</p> : null;

export default HelperMessage;
